import { useEffect } from "react";
import { useQuery } from "@apollo/client";
import { onErrorGraphql } from "utils/onErrorGraphql";
import { clientNeoFact } from "@neonumy/api-clients";
import { LIST_ANALYTICAL_TYPES } from "queries/neoFact/choices";
import { useTranslation } from "react-i18next";

export default function useGetAnalyticalTypesOptions() {
  const { t } = useTranslation();

  const { data, error } = useQuery<ListAnalyticalTypesResponse>(LIST_ANALYTICAL_TYPES, {
    client: clientNeoFact,
    fetchPolicy: "cache-first",
  });

  useEffect(() => {
    if (error) onErrorGraphql(error);
  }, [error]);

  const options =
    data?.listAnalyticalTypes?.map((item: LabelValueType) => ({
      label: t(item?.label || ""),
      value: item.value,
    })) || [];

  return { options, error };
}
